module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-6@2x__995bd7c845e9bd854fa3d1cb2f6d2a7f.png";